module.exports = __webpack_public_path__ + "static/img/gdg_addis.403250a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gdg_addis.png
// module id = 94
// module chunks = 1